<template>
    <!-- Rx Card -->
    <div class="rx-card" style="border:1px solid #ccc;border-radius:10px;box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;">
        <img src="https://rx.quility.com/wp-content/uploads/2021/10/QuilityRX_Logo_Full-Color-RGB_562x69.svg" style="margin:11px;display: block; height: auto; border: 0; width: 133px; max-width: 50%;" width="133">
        <div style="background-color: #005851;height: 2px;"></div>
        <table width="100%">
            <tr>
                <td width="50%">
                    <div style="color:#46c3b2;margin:10px 0 0 30px;font-size:12px; font-weight:500;">BIN</div>
                    <div style="color:005851;font-weight:700;margin:0 0 0 30px;">{{bin}}</div>
                </td>
                <td width="50%">
                    <div style="color:#46c3b2;margin:10px 0 0 0;font-size:12px; font-weight:500;">Group</div>
                    <div style="color:005851;font-weight:700;">{{groupCode}}</div>
                </td>
            </tr>
        </table>
        <table width="100%" class="pb-10">
            <tr>
                <td width="50%">
                    <div style="color:#46c3b2;margin:10px 0 0 30px;font-size:12px; font-weight:500;">PCN</div>
                    <div style="color:005851;font-weight:700;margin:0 0 0 30px;">{{pcn}}</div>
                </td>
                <td width="50%">
                    <div style="color:#46c3b2;margin:10px 0 0 0;font-size:12px; font-weight:500;">Member ID</div>
                    <div style="color:005851;font-weight:700;">{{id}}</div>
                </td>
            </tr>
        </table>
        <!-- card footer -->
        <div style="background-color: #005851;border-bottom-right-radius: 10px;border-bottom-left-radius: 10px;padding:5px; margin-top:15px;">
            <table width="100%">
                <tr>
                    <td>
                        <span style="color:#46c3b2;font-size:10px; font-weight:500;">QuilityRx.com
                            <!--and mobile app--> access code:<span style="font-weight: 700;"> {{groupCode}}</span></span><br />
                        <span style="color:#fff;font-size:10px; font-weight:500;">This is not insurance. This card is free.</span>
                    </td>
                    <td style="text-align: right;">
                        <div style="color:#fff;font-size: 10px; font-weight:500;">Powered by</div>
                        <img src="https://rx.quility.com/wp-content/uploads/2021/10/QuilityRX_Logo_Full-Color-on-Forest-Green_RGB_562x69.svg" style="height: auto; border: 0; width: 125px; max-width: 90%;" width="125">
                    </td>
                </tr>
            </table>
        </div>
    </div>
</template>
<script>
    export default {
    props: ['groupCode', 'id', 'pcn', 'bin'],
    data: function() {
        return {

        }
    },
    mounted: function() {

    },
    methods: {

    },
    watch: {

    }
}
</script>
<style type="text/css">
.rx-card table td {
    padding: 6px;
    line-height: 1.5;
    vertical-align: top;
    border: 0 px solid #ccc;
}
</style>